import { render } from "./DescargarApp.vue?vue&type=template&id=1ff95a72&scoped=true"
import script from "./DescargarApp.vue?vue&type=script&lang=js"
export * from "./DescargarApp.vue?vue&type=script&lang=js"

import "./DescargarApp.vue?vue&type=style&index=0&id=1ff95a72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff95a72"]])

export default __exports__